import { createBrowserHistory } from 'history';
import { listener, postRouteChangeOutOfApp } from "../routerListener/routeListener";
/**
 * We should check the window in case if we want to use the createBrowserHistory in SSR
 * */

var browserHistory = typeof window !== 'undefined' ? createBrowserHistory() : {};
/**
 * Create a new browser history and init with params
 * @param params  {Object}  Params for history
 * @return {{createHref, goBack, length, replace, go, action, location, goForward, block, push, listen}}
 */

export function createHistory() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$baseUrl = params.baseUrl,
      baseUrl = _params$baseUrl === void 0 ? '' : _params$baseUrl,
      _params$isFragment = params.isFragment,
      isFragment = _params$isFragment === void 0 ? true : _params$isFragment,
      alias = params.alias,
      _params$variant = params.variant,
      variant = _params$variant === void 0 ? 'IFRAME' : _params$variant;
  browserHistory = typeof window !== 'undefined' ? createBrowserHistory({
    basename: baseUrl
  }) : {};
  browserHistory.isFragment = isFragment;
  browserHistory.baseUrl = baseUrl;
  browserHistory.alias = alias;
  browserHistory.variant = variant;
  browserHistory.unlisten = listener(browserHistory);
  browserHistory.link = createLink(isFragment, browserHistory.location);
  return browserHistory;
}

var createLink = function createLink(isFragment, location) {
  return function (path) {
    var isNewTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (isNewTab) {
      window.top.open(path, '_blank');
    } else if (isFragment) {
      postRouteChangeOutOfApp(path, location);
    } else {
      console.error('[History] Cannot navigate to new page in non-fragment app');
    }
  };
};
/**
 * return the history instance
 * @return {{createHref, goBack, length, replace, go, action, location, goForward, block, push, listen}}
 */


export function getHistory() {
  return browserHistory;
}
export default createHistory;